import { render, staticRenderFns } from "./GlobalConfig.vue?vue&type=template&id=f7d360b4&scoped=true"
import script from "./GlobalConfig.vue?vue&type=script&lang=js"
export * from "./GlobalConfig.vue?vue&type=script&lang=js"
import style0 from "./GlobalConfig.vue?vue&type=style&index=0&id=f7d360b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d360b4",
  null
  
)

export default component.exports